/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-03-04 16:18:43                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 16:29:10                               *
 *****************************************************************************/

/* SUMMARY
  * Styles
  * Flag: Display a flag based on the ISO code
*/

/* Styles */
import { Tooltip } from "@material-tailwind/react";
import "./Flag.scss";
/***/

/**
* Flag: Display a flag based on the ISO code
* @param isoCode - The ISO code of the country 
*/
const flagCodeMap: Record<string, string> = {
  lb: "lu",
  "lb_lu": "lu",
  "lb-lu": "lu"
};

export default function Flag({
  isoCode
}: {
  isoCode: string
}) {
  const normalizedIso = isoCode ? isoCode.toLowerCase() : "";
  const flagFile = flagCodeMap[normalizedIso] || normalizedIso;

  return (
    <Tooltip content={isoCode}>
      <div className="flag-container">
        <img  src={`/assets/flags/${flagFile}.svg`}
              alt={`Flag of ${isoCode}`}/>
      </div>
    </Tooltip>
  );
}
/***/
